export default __webpack_public_path__ + "static/media/Boots of the Ubah Kan.7b16fd44.jpg";